import { UnifiedClassSkills } from "../models/UnifiedClassSkills";
import { UnifiedClassSkillsDTO } from "../dto/UnifiedClassSkillsDTO";

export const unifiedClassSkillsMapper = (
  unifiedClassSkill: UnifiedClassSkillsDTO,
): UnifiedClassSkills => {
  return new UnifiedClassSkills({
    skillId: unifiedClassSkill.skillId,
    skillName: unifiedClassSkill.skillName,
    assessment: unifiedClassSkill.assessment,
    displayOrder: unifiedClassSkill.displayOrder,
    active: unifiedClassSkill.active === "Y",
    classSkillAssignId: unifiedClassSkill.classSkillAssignId,
  });
};
